import React, { Component } from "react";
import { toast } from 'react-toastify'
import moment from "moment";
import AdmissionApi from "../../../../Services/AdmissionApi";

class UserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 1,
      id: "",
      first_name: "",
      last_name: "",
      user_name: "",
      email: "",
      phone: "",
      gender: "male",
      dateofbirth: '',
      password: "",
      errors: {
        first_name: "",
        last_name: "",
        user_name: "",
        email: "",
        phone: "",
        dateofbirth: '',
        password: "",
      },
    }

    this.admissionsService = new AdmissionApi();
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setState({
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        user_name: data.user_name,
        email: data.email,
        phone: data.phone,
        gender: data.gender,
        dateofbirth: moment(data.date_of_birth).format('YYYY-MM-DD'),
      })
    }
  }

  errorsHandling(data) {
    let errors = {};
    console.log(JSON.stringify(data));
    Object.keys(data).forEach(function (key, i) {
      errors[key] = data[key][0];
    });
    this.setState({ errors: errors });
  }

  updateState = (newResponse) => {
    if (newResponse.data.success) {
      this.props.updateRoutePage('users')
    } else {
      let errors = {};
      if (newResponse.data.message) {
        errors["responseError"] = newResponse.data.message;
        this.setState({ errors: errors });
      } else {
        // this.errorsHandling(newResponse.data.errors);
      }
    }
  }

  handleValidation = () => {
    let fields = this.state;
    let formIsValid = true;
    let errors = {
      first_name: "",
      last_name: "",
      user_name: "",
      email: "",
      phone: "",
      dateofbirth: '',
      password: "",
    }

    
    //Email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }

    //Password
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Cannot be empty";
    }

    //First_name
    if (!fields["first_name"]) {
      formIsValid = false;
      errors["first_name"] = "Cannot be empty";
    }

    if (fields["first_name"] && /[^A-Za-z \.]/.test(fields['first_name'])) {
      formIsValid = false;
      errors["first_name"] = "Special characters and numbers are not allowed";
    }

    //Last name
    if (!fields["last_name"]) {
      formIsValid = false;
      errors["last_name"] = "Cannot be empty";
    }

    if (fields["last_name"] && /[^A-Za-z \.]/.test(fields['last_name'])) {
      formIsValid = false;
      errors["last_name"] = "Special characters and numbers are not allowed";
    }

    //User name
    if (!fields["user_name"]) {
      formIsValid = false;
      errors["user_name"] = "Cannot be empty";
    }

    //Phone
    if (!fields["phone"]) {
      formIsValid = false;
      errors["phone"] = "Cannot be empty";
    }

    if (fields["phone"] && !fields["phone"].match(/^\d{10}$/)) {
      formIsValid = false;
      errors["phone"] = "Phone is not valid"
    }

    //dateofbirth
    if (!fields["dateofbirth"]) {
      formIsValid = false;
      errors["dateofbirth"] = "Cannot be empty";
    }

    errors["responseError"] = "";

    this.setState({ errors });
    return formIsValid;
  }

  onSubmit = () => {
    if (!this.handleValidation()) return
    const {
      id,
      type,
      first_name,
      last_name,
      user_name,
      phone,
      gender,
      dateofbirth,
      email,
      password
    } = this.state

    let obj = {
      school_code: 'admin',
      first_name: first_name.trim(),
      last_name: last_name.trim(),
      user_name: user_name,
      gender: gender,
      date_of_birth: moment(dateofbirth).format('YYYY-MM-DD'),
      phone: phone,
    }

    if (id) obj['id'] = id
    if (!id) obj['type'] = type
    if (!id) obj['email'] = email
    if (!id) obj['password'] = password
    if (!id) obj['active'] = 1

    if (!id) {
      this.admissionsService.createNew(
        res => {
          if(res.status === 200) {
            toast.success(("User added successfully."))
            this.updateState()
          }
        },
        obj,
        "v1/users"
      )
    } else {
      this.admissionsService.updateCredentials(
        res => {
          if(res.status === 200) {
            toast.success(("User updated successfully."))
            this.updateState()
          }
        },
        obj,
        "v1/users"
      )
    }
  }

  resetErrorMsg = (errorId) => {
    this.setState((preState) => ({
      errors: { ...preState.errors, [errorId]: "" },
    }))
  }

  handleFormFieldChange = (e) => {
    const { id, value } = e.target
    this.setState({
      [id]: value
    })

    this.resetErrorMsg(id)
  }

  render() {
    const {
      id,
      first_name,
      last_name,
      user_name,
      email,
      phone,
      gender,
      dateofbirth,
      password,
      errors
    } = this.state
    const { updateRoutePage } = this.props

    return (
      <div className="container">
        <div className="row">
          <div className={`col-sm-12 ${!id && 'col-lg-6'}`}>
            <div className={`form-group ${errors["email"] && 'm-0'}`}>
              <label>Email</label>
              <input
                type="text"
                id="email"
                className="form-control alert-filter__input"
                placeholder="Email"
                readOnly={id && true}
                value={email}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["email"]}
            </span>
          </div>
          {!id && (
            <div className="col-sm-12 col-lg-6">
              <div className={`form-group ${errors["password"] && 'm-0'}`}>
                <label>Password</label>
                <input
                  type="password"
                  id="password"
                  className="form-control alert-filter__input"
                  placeholder="Password"
                  value={password}
                  onChange={this.handleFormFieldChange}
                />
              </div>
              <span style={{ color: "red", fontFamily: "italian" }}>
                {errors["password"]}
              </span>
            </div>
          )}
          <div className="col-sm-12 col-lg-6">
            <div className={`form-group ${errors["first_name"] && 'm-0'}`}>
              <label>First Name</label>
              <input
                type="text"
                id="first_name"
                className="form-control alert-filter__input"
                placeholder="First Name"
                value={first_name}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["first_name"]}
            </span>
          </div>
          <div className="col-sm-12 col-lg-6">
            <div className={`form-group ${errors["last_name"] && 'm-0'}`}>
              <label>Last Name</label>
              <input
                type="text"
                id="last_name"
                className="form-control alert-filter__input"
                placeholder="Last Name"
                value={last_name}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["last_name"]}
            </span>
          </div>
          <div className="col-sm-12 col-lg-6">
            <div className={`form-group ${errors["user_name"] && 'm-0'}`}>
              <label>Username</label>
              <input
                type="text"
                id="user_name"
                className="form-control alert-filter__input"
                placeholder="Username"
                value={user_name}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["user_name"]}
            </span>
          </div>
          <div className="col-sm-12 col-lg-6">
            <div className={`form-group ${errors["dateofbirth"] && 'm-0'}`}>
              <label>Date of birth</label>
              <input
                type="date"
                id="dateofbirth"
                max={moment().format('YYYY-MM-DD')}
                className="form-control alert-filter__input"
                value={dateofbirth}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["dateofbirth"]}
            </span>
          </div>
          <div className="col-sm-12 col-lg-6">
            <label>Gender</label>
            <div>
              <label className="u-check" style={{ width: '50%' }}>
                <input
                  type="radio"
                  style={{ display: "none" }}
                  id="gender"
                  checked={gender === "male"}
                  value="male"
                  onChange={this.handleFormFieldChange}
                />
                <span style={{ lineHeight: 0.9 }} className="btn btn-md btn-block u-btn-outline-lightgray g-color-white--checked rounded-0">
                  Male
                </span>
              </label>
              <label className="u-check" style={{ width: '50%' }}>
                <input
                  type="radio"
                  style={{ display: "none" }}
                  id="gender"
                  checked={gender === "female"}
                  value="female"
                  onChange={this.handleFormFieldChange}
                />
                <span style={{ lineHeight: 0.9 }} className="btn btn-md btn-block u-btn-outline-lightgray g-color-white--checked rounded-0">
                  Female
                </span>
              </label>
              <br />
              <span style={{ color: "red" }}>
                {errors["gender"]}
              </span>
            </div>
          </div>
          <div className="col-sm-12 col-lg-6">
            <div className={`form-group ${errors["phone"] && 'm-0'}`}>
              <label>Phone</label>
              <input
                type="text"
                id="phone"
                className="form-control alert-filter__input"
                placeholder="Phone"
                value={phone}
                onChange={this.handleFormFieldChange}
              />
            </div>
            <span style={{ color: "red", fontFamily: "italian" }}>
              {errors["phone"]}
            </span>
          </div>
          <div className="col-12 text-right my-3">
            <button
              onClick={() => updateRoutePage('users')}
              className="btn btn-link"
            >
              Cancel
            </button>
            <button
              onClick={() => this.onSubmit()}
              className="btn btn--primary ml-2"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default UserForm



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Users/UserForm/index.js
 **/